import { useEffect } from 'react';

export const useOnUnmount = (onUnmount: () => any) => {
  return useEffect(() => {
    return onUnmount;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- on unmount
  }, []);
};
